<template>
    <div class="position-relative component">
        <div class="text-center pt-5 pb-5 d-flex flex-column gap-4 align-items-center">
            <h1>
                {{ trans('general.space_setup.welcome') }}
            </h1>
            <p class="mt-2" style="max-width: 450px;">
                {{ trans('general.space_setup.welcome_text') }}
            </p>
        </div>

        <setup-footer ref="setupFooter" :step="step" v-on="$listeners"/>
    </div>
</template>

<script>
import SetupFooter from "../molecules/SetupFooter.vue";

export default {
    name: "Welcome",
    components: {SetupFooter},
    props: {
        step: {
            type: Number
        }
    },
    mounted() {
        this.$refs.setupFooter.setButtonText(trans('general.space_setup.start'));
    }
}
</script>
